module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAA2CAMAAADnEdnLAAAAM1BMVEX////ljjjsrnvyy6755tnvvZbqpm39+fb88+zonl367OPttonnlkv12cT00rnxxKL3388pl0GfAAAAyklEQVR4Xu3N2W7DIBBGYc4M6+Ik7/+0LdipamXMRZe7nBsQn9Dv/q13OsoT0k1EbunEjPzQ2hn1+p1F4sEFeigQ3Sm/8wZhjMFmcYMxm6BZXJB9jWIx3Cc3sFknq83PTbE5EoeO0+IA+VMzBIs9RO9yg8eJdWfXgAiIMzkJI0lnzt4fL1VVq/vb8uafqcGer7BZZvGKj8sV6yzAcvtnv8tqWymrbV1vC7LYTrAtthXyNdeOTNNHoL/wHepkgOBeCrf9FJGW3W969wFnMgSEEpV8GQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/pin_oct.png
// module id = 1694
// module chunks = 1